<template>
  <el-select class="w100" v-model="modelValue" :multiple="multiple" :placeholder="placeholder" @change="handleChange">
    <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"
      @click="handleItemClick(item)" />
  </el-select>
</template>

<script lang="ts" setup>
import { ref, toRefs } from 'vue';

const props = defineProps<{
  options: { label: string, value: string }[]
  placeholder: string
  multiple: boolean
  modelValue: string | string[]
}>()
const { options, modelValue, placeholder, multiple } = toRefs(props)
const emit = defineEmits(['update:modelValue', 'change', 'item-click'])

const handleChange = () => {
  emit('update:modelValue', modelValue.value)
  emit('change', modelValue.value)
}
const handleItemClick = (item: { label: string, value: string }) => {
  emit('item-click', item)
}
</script>